import { UsersIcon as icon } from "lucide-react"
import edit from "./users.edit"
import list from "./users.list"
import { UserRecord } from "./users.types"

const crud = (permissions: Record<string, string[]>) => ({
  name: "users",
  options: { label: "Users" },
  list:
    "users" in permissions && permissions.users.includes("list")
      ? list
      : undefined,

  edit:
    "users" in permissions && permissions.users.includes("edit")
      ? edit
      : undefined,
  icon,

  recordRepresentation: (record: UserRecord): string =>
    `${record.first_name ?? ""} ${record.last_name ?? ""}`.trim(),
})

export default crud
